import { CondensedButton, ListCard } from '@capsicum/common-web';
import styled from 'styled-components';

export const ListCardWrapper = styled(ListCard)`
	width: 100%;
	height: 103px;
	padding: ${({ theme }) => theme.spacings.small} ${({ theme }) => theme.spacings.small}
		${({ theme }) => theme.spacings.small} 0;
`;
export const FirstRow = styled(ListCard.Row)`
	align-items: center;
`;
export const ListCardTitle = styled(ListCard.Title)`
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
	max-width: 250px;
	${({ theme }) => theme.breakpoints.queries.only.mobile} {
		max-width: 115px;
	}
`;
export const ListCardSubTitle = styled(ListCard.SubTitle)`
	flex: 1;
`;
export const ListCardText = styled(ListCard.Text)`
	${({ theme }) => theme.fonts.text.text1}
	white-space: nowrap;
`;
export const ListCardBottomText = styled(ListCard.Text)`
	${({ theme }) => theme.fonts.text.caption1}
`;
export const ListCardBottomTextWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: ${({ theme }) => theme.spacings.xxxxsmall};
`;
export const ListCardEndTop = styled(ListCard.End)`
	align-items: flex-start;
	margin-left: 0;
	align-self: center;
	display: flex;
`;

export const PrimaryButtonWrapper = styled.div`
	display: flex;
	flex: 1;
	justify-content: flex-end;
	align-items: center;
`;

export const PrimaryButton = styled(CondensedButton)`
	align-self: flex-end;
	min-width: 92px;
`;

export const RightFirstRowWrapper = styled.div`
	justify-content: flex-end;
	text-align: end;
	display: flex;
	flex-direction: column;
`;
export const DefaultCurrencyContainer = styled.span`
	${({ theme }) => theme.fonts.text.caption1};
	color: ${({ theme }) => theme.colors.text.main.subtle};
`;
export const AltCurrencyContainer = styled(ListCard.Text)`
	${({ theme }) => theme.fonts.text.caption2}
	color: ${({ theme }) => theme.colors.text.main.subtle};
`;
export const ContentWrapper = styled.div<{
	$clickable: boolean;
}>`
	width: 100%;
	display: flex;
	flex-direction: row;
	order: 2;
	${({ $clickable }) => $clickable && `cursor: pointer`}
	${({ $clickable, theme }) => !$clickable && `padding-right: ${theme.spacings.medium}`}
`;
export const ListCardContent = styled(ListCard.Content)`
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;
export const ListCardSubTitleAmount = styled(ListCard.SubTitle)`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: ${({ theme }) => theme.spacings.xsmall};
`;
export const CurrencyContainer = styled.div`
	justify-content: flex-end;
	text-align: end;
	display: flex;
	gap: ${({ theme }) => theme.spacings.xxxsmall};
`;
